import * as React from "react";
const SvgFiBrandsAndroid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-android_svg__a)">
      <path
        fill="#151A2D"
        d="M17.523 15.342a1 1 0 1 1-.001-1.999 1 1 0 0 1 .001 1.999m-11.046 0a1 1 0 1 1-.001-1.999 1 1 0 0 1 .001 1.999m11.404-6.02 1.997-3.459a.415.415 0 1 0-.72-.416L17.136 8.95A12.3 12.3 0 0 0 12 7.851c-1.853 0-3.59.393-5.137 1.098L4.841 5.447a.416.416 0 0 0-.72.415l1.997 3.46c-3.43 1.865-5.775 5.337-6.119 9.44h24c-.343-4.103-2.688-7.575-6.118-9.44"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-android_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAndroid;
